/* Zapp sale countdown — ticks a Hrs/Mins/Secs display.
   mode "daily" counts to the next local midnight (evergreen),
   mode "fixed" counts to data-end (ISO datetime) and hides itself at zero. */
class ZappCountdown extends HTMLElement {
  connectedCallback() {
    this.hoursEl = this.querySelector('[data-cd-hours]');
    this.minsEl = this.querySelector('[data-cd-mins]');
    this.secsEl = this.querySelector('[data-cd-secs]');
    if (!this.hoursEl) return;
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  target() {
    if (this.dataset.mode === 'fixed' && this.dataset.end) {
      return new Date(this.dataset.end);
    }
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return midnight;
  }

  tick() {
    let ms = this.target() - new Date();
    if (ms <= 0) {
      if (this.dataset.mode === 'fixed') {
        this.hidden = true;
        clearInterval(this.timer);
        return;
      }
      ms = 0;
    }
    const total = Math.floor(ms / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    this.hoursEl.textContent = pad(Math.floor(total / 3600));
    this.minsEl.textContent = pad(Math.floor((total % 3600) / 60));
    this.secsEl.textContent = pad(total % 60);
  }
}

if (!customElements.get('zapp-countdown')) {
  customElements.define('zapp-countdown', ZappCountdown);
}
